module.exports = __webpack_public_path__ + "fonts/CashSans-Light.86da7e8.woff2";